<template>
  <div class="hd-view" v-if="title">
    <div class="back-btn">
      <div @click="back">
        <img v-if="backShow" src="../../assets/images/IndexImages/angle-left.svg" class="back-img">
      </div>
    </div>
    <div v-html="title" class="title"></div>
  </div>
</template>

<script>
  export default {
    name: 'nav-header',
    props: {
      title: {
        type: String,
        default: ""
      },
      backShow: {
        type: Boolean
        // default: false
      },
      backRoute: {
        type: String,
        default: ""
      },
      backAppCode: {
        type: String,
        default: ""
      }
    },
    data: function () {
      return {
      }
    },
    components: {
    },
    methods: {
      back() {
        if(this.backRoute) {
          if(this.backAppCode) {
            this.$router.replace({path: this.backRoute, query: {appCode: this.backAppCode}})
          } else {
            this.$router.replace({path: this.backRoute})
          }
        } else {
          this.$router.back()
        }
      },
    }
  }
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/navHeader.vue